import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 3, height: 4, fill: "none", viewBox: "0 0 3 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 1.5, cy: 2, r: 1.5, fill: "#98A9BC", opacity: 0.5 }));
const ForwardRef = forwardRef(SvgCircle);
export { ForwardRef as ReactComponent };
